/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023 (original work) Open Assessment Technologies SA
 */
import { __ } from '@oat-sa-private/ui-core';
import { tabKeys } from '@/core/utils/consts';

/**
 * Get the translated UI label for a tab
 * (based on deliveryExecution.status, but tab can hold several different statuses)
 * @param {String} tabKey
 * @returns {String}
 */
export function getTabLabel(tabKey) {
    const parentTabLabels = {
        [tabKeys.notStarted]: __('Not started'),
        [tabKeys.inProgress]: __('In progress'),
        [tabKeys.paused]: __('Paused'),
        [tabKeys.finished]: __('Finished')
    };
    return parentTabLabels[tabKey] || '';
}